import * as React from 'react'
import { Flex } from '@mprolab/uikit'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

export const Wrapper = styled(Flex)`
  cursor: pointer;
  padding: 8px;
  height: max-content;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  font-weight: 600;
  font-size: 12px;
  background: ${({ theme }) => theme.colors.gray7};
  border-radius: 8px;
  line-height: normal;
  font-weight: 600;
  text-decoration: upper-case;
  transition: all 0.3s ease-in-out;
  &:hover {
    background: ${({ theme }) => theme.colors.white3};
  }
`

interface MaxButtonProps {
  onClick: (e: any) => void
}

const MaxButton: React.FC<MaxButtonProps> = ({ onClick }) => {
  const { t } = useTranslation()
  return <Wrapper {...{ onClick }}>{t('general.max').toUpperCase()}</Wrapper>
}

export default MaxButton
